var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHkexNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 400 200",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-33.278 -15.134)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(96 0 0 96 38.826 103.91)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.083-0.69h0.219v0.268h0.203v-0.268h0.219v0.69h-0.219v-0.281h-0.203v0.281h-0.219v-0.69z",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(96 0 0 96 116.36 103.91)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.302-0.292v0.292h-0.219v-0.69h0.219v0.304l0.156-0.304h0.255l-0.197 0.331 0.197 0.359h-0.255l-0.141-0.325-0.015 0.033z",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(96 0 0 96 45.857 187.91)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.083-0.69h0.485v0.128h-0.266v0.145h0.235v0.125h-0.235v0.151h0.266v0.141h-0.485v-0.69z",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(96 0 0 96 107.68 187.91)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.518-0.344 0.172 0.344h-0.266l-0.088-0.26-0.118 0.26h-0.2l0.172-0.344-0.172-0.346h0.266l0.105 0.244 0.113-0.244h0.188l-0.172 0.346z",
    fillRule: "nonzero"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m204.05 168.86h-12.486l-17.596-97.741-9.153 97.741h-12.486l13.597-145.47h12.53l17.64 97.344 9.109-97.344h12.441l-13.596 145.47z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.55 125h-31.992c-0.03 1.124-0.044 1.984-0.044 2.579 0 7.013 0.896 12.669 2.688 16.969 1.792 4.299 3.977 6.449 6.554 6.449 4.236 0 7.539-4.895 9.908-14.685l11.42 4.266c-2.222 10.254-5.191 17.944-8.909 23.071s-7.887 7.69-12.508 7.69c-6.339 0-11.494-4.482-15.463-13.445-3.969-8.964-5.954-20.822-5.954-35.574 0-14.421 1.792-27.254 5.376-38.5 4.888-15.215 11.864-22.823 20.929-22.823 5.776 0 10.367 3.986 13.774 11.957s5.11 19.135 5.11 33.49c0 6.88-0.296 13.065-0.889 18.556zm-10.753-17.365c0.03-1.257 0.045-2.217 0.045-2.878 0-7.806-0.785-13.661-2.355-17.564s-3.673-5.854-6.31-5.854c-2.636 0-4.999 2.216-7.087 6.648s-3.503 10.982-4.243 19.648h19.95z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m317.53 168.86h-11.997l-2.311-67.079-14.396 67.079h-11.819l-5.91-105.38h11.33l3.289 70.651 14.707-70.651h11.597l1.6 70.651 14.619-70.651h12.796l-23.505 105.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m337.35 139.38 12.353-4.366c1.096 5.821 2.459 9.939 4.088 12.354 1.629 2.414 3.851 3.621 6.665 3.621 2.903 0 5.228-1.455 6.976-4.366 1.214-1.984 1.822-4.399 1.822-7.243 0-1.919-0.311-3.639-0.933-5.16-0.652-1.456-2.415-3.242-5.288-5.359-7.702-5.689-12.471-10.187-14.308-13.495-2.873-5.16-4.31-11.907-4.31-20.242s1.393-15.513 4.177-21.533c3.881-8.401 9.642-12.602 17.285-12.602 6.072 0 10.664 2.481 13.774 7.442 3.111 4.962 5.08 11.676 5.91 20.144l-11.775 4.564c-0.622-3.837-1.629-6.714-3.022-8.633-1.895-2.58-4.176-3.87-6.842-3.87s-4.584 0.993-5.754 2.977c-1.171 1.985-1.756 4.267-1.756 6.847 0 2.646 0.593 4.829 1.778 6.549 0.74 1.058 3.125 2.911 7.154 5.557 6.22 4.035 10.382 8.004 12.485 11.907 2.963 5.491 4.444 12.106 4.444 19.846 0 9.989-1.881 18.655-5.643 25.998s-9.065 11.014-15.908 11.014c-6.813 0-12.078-2.795-15.796-8.385-3.717-5.589-6.243-13.445-7.576-23.566z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHkexNews);
export default __webpack_public_path__ + "static/media/hkex-news.0518ef8478e2bfaffd955d5a54aa3d02.svg";
export { ForwardRef as ReactComponent };